import React, { useEffect, useState } from "react";
import { TiEdit } from "react-icons/ti";
import { IoTrashOutline } from "react-icons/io5";
import DeleteTestMethod from "./TestMethod/DeleteTestMethod";
import EditTestMethod from "./TestMethod/EditTestMethod";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  addAllTestMethod,
  addToTestMethod,
  selectTestMethods,
} from "../../../GlobalData/Basic Plugins/TestMethodSlice";
import { Oval } from "react-loader-spinner";
import axios from "axios";

function TestMethod({ type }) {
  const [OpenDeleteTestMethod, setOpenDeleteTestMethod] = useState(false);
  const [OpenEditTestMethod, setOpenEditTestMethod] = useState(false);
  const dispatch = useDispatch();
  const TestMethodSelector = useSelector(selectTestMethods);
  const [id, SetId] = useState(0);
  const [error, setError] = useState("");
  const [name, setName] = useState("");

  const GetTestMethods = async () => {
    document.getElementById("Loader").classList.remove("hidden");
    document.getElementById("Loader").classList.add("flex");
    await axios
      .get(`admin-scope/get-TestMethods`)
      .then((response) => {
        document.getElementById("Loader").classList.add("hidden");
        document.getElementById("Loader").classList.remove("flex");
        dispatch(addAllTestMethod(response.data));
      })
      .catch((err) => {
        document.getElementById("Loader").classList.add("hidden");
        document.getElementById("Loader").classList.remove("flex");
        console.log("data");
      });
  };
  useEffect(() => {
    GetTestMethods();
  }, []);

  const ADDToTheTable = async () => {
    // document.getElementById("Loader").classList.remove("hidden");
    // document.getElementById("Loader").classList.add("flex");
    // await axios
    //   .post("lab-scope/create-company", { name: name })
    //   .then((response) => {
    //     GetTestMethods();
    //     setError("");
    //     setName("");
    //   })
    //   .catch((err) => {
    //     setError(err.response.data.message);
    //     document.getElementById("Loader").classList.add("hidden");
    //     document.getElementById("Loader").classList.remove("flex");
    //   });
  };

  const Edit = (id) => {
    // SetId(id);
    // setOpenEditTestMethod(true);
  };

  const Delete = (id) => {
    // SetId(id);
    // setOpenDeleteTestMethod(true);
  };
  const handleChangeName = (e) => {
    setName(e.target.value);
  };
  return (
    <div className={`${type === "TestMethod" ? "block" : "hidden"} mt-10`}>
      <DeleteTestMethod
        id={id}
        open={OpenDeleteTestMethod}
        setOpen={setOpenDeleteTestMethod}
      />
      <EditTestMethod
        id={id}
        open={OpenEditTestMethod}
        setOpen={setOpenEditTestMethod}
      />
      <div className="">
        <div className="border-[#E4E7EC] w-full h-fit bg-[#F9FAFF] flex space-x-2 items-center py-3 px-4     relative m-auto border-[1px] rounded-xl ">
          <input
            id="TestMethodName"
            placeholder={t("Test method")}
            onChange={handleChangeName}
            value={name}
            type="text"
            className="w-full bg-[#F9FAFF] font-Poppins-Regular text-xs text-[#707070] outline-0 ring-0"
          />
        </div>
        <div className="w-full flex justify-end mt-5">
          <div
            className="col-start-3 col-end-4 bg-[#0D2135]   flex items-center justify-center px-10 w-fit py-2 rounded-xl cursor-pointer "
            onClick={() => ADDToTheTable()}
          >
            <p className="text-sm flex items-center justify-center text-white font-Poppins-Regular">
              {t("Add To the Table")}
            </p>
          </div>
        </div>
        <div
          id="Loader"
          className="hidden   justify-center items-center mt-5 w-full text-center mx-auto"
        >
          <Oval
            height={30}
            width={30}
            color="#4fa94d"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
        <table className="w-full h-full mt-5  bg-white  rounded-2xl col-start-1 col-end-4 ">
          <tr className="border-b-[1px] w-full">
            <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-2 pl-5 w-[90%]">
              {t("Test method")}
            </td>
            <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-2 w-[10%]">
              {t("Action")}
            </td>
          </tr>
          {TestMethodSelector
            ? TestMethodSelector.map((Method) => (
                <tr className="border-b-[1px] w-full">
                  <td className="text-base text-[#101828] font-semibold font-Poppins-Regular py-2 pl-5 ">
                    {Method.test_method}
                  </td>
                  <td className="text-sm text-[#101828] font-semibold font-Poppins-Regular py-2 ">
                    <div className="flex space-x-2 ">
                      <TiEdit
                        className="text-2xl  opacity-50 cursor-pointer"
                        onClick={() => Edit(Method.id)}
                      />
                      <IoTrashOutline
                        className="text-2xl text-[#F04438] cursor-pointer"
                        onClick={() => Delete(Method.id)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            : "Loading"}
          <tr className="border-b-[1px] w-full">
            <td className="text-base text-[#101828] font-semibold font-Poppins-Regular py-2 pl-5 ">
              Test method name2
            </td>
            <td className="text-sm text-[#101828] font-semibold font-Poppins-Regular py-2 ">
              <div className="flex space-x-2 ">
                <TiEdit className="text-2xl  opacity-50 cursor-pointer" />
                <IoTrashOutline className="text-2xl text-[#F04438] cursor-pointer" />
              </div>
            </td>
          </tr>
        </table>
        <div className=" flex justify-end space-x-8 mt-8 col-start-1 col-end-4">
          <div className="bg-transparent border-[1px] border-[#D0D5DD] w-fit  flex items-center justify-center px-16 py-2 rounded-xl cursor-pointer ">
            <p className="text-sm flex items-center justify-center text-black font-Poppins-Regular">
              {t("Cancel")}
            </p>
          </div>
          <div className="bg-[#B7C835] w-fit  flex items-center justify-center px-28 py-3 rounded-xl cursor-pointer ">
            <p className="text-sm flex items-center justify-center text-white font-Poppins-Regular">
              {t("Save")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestMethod;
